import React from 'react';

interface Props {
    category: string;
}

const ExposureCategoryColumn: React.FC<Props> = ({ category }) => {
    return (
        <div className="flex items-center text-sm">
                {category}
        </div>
    );
};

export default ExposureCategoryColumn;
